<template>
  <div class="checkbox-group">
    <template v-for="(option, index) in options" :key="option.value">
      <h3
        v-if="showYearHeader(option, index)"
        class="year-header font-extrabold text-[0.8125rem] sm:text-[0.875rem] text-[1rem] md:text-[1.125rem] lg:text-[1.25rem] text-[#191817] font-inter leading-20 sm:leading-24 md:leading-28 pb-[8px]"
        :class="{ '!pt-[16px]': index !== 0 && options[index - 1].year !== option.year }"
      >
        Year {{ option.year }}
      </h3>
      <div class="option-wrapper">
        <div
          :class="isSelected(option.value) ? 'bg-[#E8DCC766] border-[2px]' : ''"
          class="flex items-center cursor-pointer p-[8px] sm:p-[10px] md:p-[12px] rounded-[10px] border-[1px] border-solid border-[#A5A4A3]"
          @click="selectOption(option.value)"
        >
          <div
            class="w-[16px] h-[16px] sm:w-[18px] sm:h-[18px] md:w-[20px] md:h-[20px] lg:w-[24px] lg:h-[24px] flex items-center justify-center mr-2 sm:mr-3 md:mr-4"
          >
            <img
              v-if="isSelected(option.value)"
              src="/assets/icons/calendar/radio-button-filled.svg"
              alt=""
            />
            <img v-else src="/assets/icons/calendar/radio-button.svg" alt="" />
          </div>
          <label
            :class="{ '!font-bold': isSelected(option.value) }"
            class="text-[0.8125rem] sm:text-[0.875rem] text-[1rem] md:text-[1.125rem] lg:text-[1.25rem] font-inter font-medium leading-20 sm:leading-24 md:leading-28 text-[#3C3A36] select-none !mb-0 flex items-center"
          >
            {{ option.label }}
          </label>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'YearRadioGroup',
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
      validator(value) {
        return value.every(
          option =>
            Object.prototype.hasOwnProperty.call(option, 'value') &&
            Object.prototype.hasOwnProperty.call(option, 'label'),
        );
      },
    },
  },
  emits: ['update:modelValue'],
  methods: {
    selectOption(value) {
      this.$emit('update:modelValue', value);
    },
    isSelected(optionValue) {
      return this.modelValue === optionValue;
    },
    showYearHeader(option, index) {
      return option.year && (index === 0 || this.options[index - 1].year !== option.year);
    },
  },
};
</script>

<style scoped>
.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

@media (min-width: 640px) {
  .checkbox-group {
    gap: 12px;
  }
}

.checkbox-group > div {
  break-inside: avoid;
}

.year-header {
  grid-column: 1 / -1;
}

.option-wrapper {
  break-inside: avoid;
}
</style>
